import { Link } from 'react-router-dom'

export function EmptyState({ type = 'no-projects' }) {
  const states = {
    'no-projects': {
      icon: (
        <svg className="w-20 h-20 text-neutral-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      title: 'No projects yet',
      description: 'Start following projects to track updates and reserve units when they become available.',
      action: {
        label: 'Browse Projects',
        to: '/projects',
      },
    },
    'no-reservations': {
      icon: (
        <svg className="w-20 h-20 text-neutral-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      ),
      title: 'No reservations',
      description: 'When you reserve a unit, it will appear here with all the details you need.',
      action: null,
    },
    'loading': {
      icon: (
        <div className="spinner spinner-lg text-primary-600"></div>
      ),
      title: 'Loading your dashboard',
      description: 'Please wait while we fetch your projects...',
      action: null,
    },
  }

  const state = states[type] || states['no-projects']

  return (
    <div className="bg-white rounded-2xl border border-neutral-200 p-12 md:p-16">
      <div className="max-w-md mx-auto text-center">
        <div className="flex items-center justify-center mb-6">
          {state.icon}
        </div>

        <h3 className="text-xl font-semibold text-neutral-900 mb-3">
          {state.title}
        </h3>

        <p className="text-neutral-600 mb-6 leading-relaxed">
          {state.description}
        </p>

        {state.action && (
          <Link
            to={state.action.to}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-xl hover:bg-primary-700 font-semibold transition-colors shadow-sm hover:shadow-md"
          >
            {state.action.label}
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        )}
      </div>
    </div>
  )
}
